<template>
  <button
    type="button"
    class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
    role="menuitem"
    v-close-popper
    @click="openDialog"
  >
    Custom email
  </button>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    openDialog() {
      this.$modal.show({
        component: () => import('./thirdPartyServiceList/CustomEmailServiceDialog.vue'),
        props: {
          accountId: this.accountId,
        },
        on: {},
        hideEvent: 'close',
      });
    },
  },
};
</script>
